﻿import { ScaleLine } from 'ol/control';
import * as eventTypes from '../../../map/utils/eventTypes';
export default class ScaleControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.control = null;
        this.scaleList = 'scale-list-' + this.classId + '-' + this.action.Id;
        this.scaleInput = 'scale-input-' + this.classId + '-' + this.action.Id;
    }

    init() {
        if (this._isMobileDevice()) return;
        let uom = this.mapControl.map.getView().getProjection().getUnits();
        let uomString = 'metric';

        switch (uom) {
            case 'm': uomString = 'metric';
                break;
            case 'degrees': uomString = 'degrees';
                break;
        }

        this.control = new ScaleLine({
            units: uomString,
            bar: true,
            steps: 5,
            minWidth: 140
        });

        this.mapControl.map.addControl(this.control);

        let div = document.createElement('div');
        div.innerHTML = this._getTemplate();
        this.menuContainer.append(div.firstChild);
        this._populateScaleSelector();

        $event.register(eventTypes.SCALE_CHANGED, this._getScaleChangedHandler(), this, this.classId);

        $('#' + this.scaleInput).on('keyup', (evt) => {
            if (evt.key === 'Enter') {
                let value = $('#' + this.scaleInput).val();

                value = value.trim().replaceAll(' ', '')
                    .replaceAll('1:', '')
                    .replaceAll('.', '')
                    .replaceAll(',', '');
                let scale = new Number(value);

                if (!isNaN(scale)) {
                    this.mapControl.setScale(scale);
                }
            }
        });

        $('#' + this.scaleList).on('change', () => {
            var selectedValue = $('#' + this.scaleList).val();
            selectedValue = selectedValue.trim().replaceAll(' ', '')
                .replaceAll('1:', '')
                .replaceAll('.', '')
                .replaceAll(',', '');
            let scale = new Number(selectedValue);

            if (!isNaN(scale)) {
                this.mapControl.setScale(scale);
            }
        });

        let initialScale = this.mapControl.getViewScale();
        $('#' + this.scaleInput).val('1 : ' + parseInt(initialScale).toLocaleString());
    }

    _isMobileDevice() {
        let supportsTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints) && (window.innerWidth < 750);
        return supportsTouch;
    }

    _getScaleChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                $('#' + this.scaleInput).val(data.scale);
            }
        };

        return handler;
    }

    _populateScaleSelector() {
        var scaleValues = [500, 1000, 5000, 10000, 50000, 100000, 500000, 1000000];
        var datalistElement = document.getElementById(this.scaleList);

        datalistElement.innerHTML = '';

        scaleValues.forEach(function (scale) {
            var option = document.createElement("option");
            option.value = `1 : ${scale.toLocaleString()}`;
            option.innerText = `1 : ${scale.toLocaleString()}`;
            datalistElement.appendChild(option);
        });
    }

    _getTemplate() {
        return `<div class="scale-input">
                    <select id="` + this.scaleList + `" class="scale-select"></select>
                    <input id="` + this.scaleInput + `" class="scale-input-item" type="text"></input>
                </div>`;
    }
}